import "./ClockOut.scss";
import "../AdminCards/ClockInStats/ClockInStats.scss";

import { useMemo } from "react";
import { useSelector } from "react-redux";
import { iconPicker } from "../AdminCards/ClockInStats/iconPicker";
import { HollowDotsSpinner } from "react-epic-spinners";
import { selectOpenShifts } from "../../selectors/todayClockings";

const ClockOuts = () => {
  const { eligibleEmployeesClockIn } = useSelector(
    (state) => state.employeesList
  );
  const { isDarkMode } = useSelector((state) => state.usersList);
  const { clockings } = useSelector((state) => state.clockings);
  const openShifts = useSelector(selectOpenShifts);

  const missedClockOutUsers = useMemo(() => {
    if (!clockings || !eligibleEmployeesClockIn?.length) {
      return null;
    }
    const openIds = new Set(openShifts.map((el) => el?.employeeId));
    return eligibleEmployeesClockIn.filter((el) => openIds.has(el?.employeeId));
  }, [clockings, eligibleEmployeesClockIn, openShifts]);

  return (
    <>
      {!!missedClockOutUsers ? (
        <div className="delayed-clockouts-container">
          {missedClockOutUsers?.map((dco) => {
            return (
              <div className="dep-icon" key={dco?.employeeId}>
                <div
                  key={dco?.employeeId}
                  className="dep-icon-text"
                  style={{ width: "40%" }}
                >
                  {dco?.employeeFirstName + " " + dco?.employeeLastName}
                </div>

                <div
                  style={{
                    width: "60%",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  {iconPicker(
                    dco?.employeeDepartmentName,
                    isDarkMode ? "#e6e6e6" : "#323338"
                  )}
                  <div className="dep-icon-text">
                    {dco.employeeDepartmentName}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <HollowDotsSpinner color="#1da193" size={24} />
        </div>
      )}
    </>
  );
};
export default ClockOuts;
